export type DomainErrorCode =
    | 'VALIDATION'
    | 'APPROVED_STRUCTURE'
    | 'STALE_REFERENCE'
    | 'REVIEW_LOCKED';

export abstract class DomainError extends Error {
    abstract readonly code: DomainErrorCode;

    constructor(message: string) {
        super(message);
        // Restore prototype chain — required for instanceof to work after transpilation.
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = new.target.name;
    }
}

export class DomainValidationError extends DomainError {
    readonly code = 'VALIDATION';
}

export class ApprovedStructureError extends DomainError {
    readonly code = 'APPROVED_STRUCTURE';
}

export class StaleReferenceError extends DomainError {
    readonly code = 'STALE_REFERENCE';
}

/**
 * Thrown when a per-ROI review action (approve/reject/unapprove) targets
 * a ROI whose parent structure set is signed off (APPROVED or REJECTED).
 * A signed-off set is locked; the reviewer must unapprove the whole set
 * before re-reviewing individual structures. See the revised design §2.9.
 */
export class ReviewLockedError extends DomainError {
    readonly code = 'REVIEW_LOCKED';
}
